import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get<User[]>(`${API}users`);
  }

  getMe() {
    return this.http.get<User>(`${API}users/me`);
  }

  create(user: User) {
    return this.http.post<User>(`${API}users`, user);
  }

  update(id: number, user: User) {
    return this.http.put<User>(`${API}users/${id}`, user);
  }

  updateBusiness(id: number, data) {
    return this.http.put<User>(`${API}users/business/${id}`, data);
  }

  getUsersByType(type: string) {
    return this.http.get(`${API}users/user-type/${type}`);
  }
}
